export default __webpack_public_path__ + "static/media/Case-Campanhas.79bab4fa.jpg";